import { useAuthStore } from '@/stores/auth.js';

const BASE = '/api';

async function request(method, path, body, opts = {}) {
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) };
  const token = useAuthStore.getState().token;
  if (token) headers.Authorization = `Bearer ${token}`;
  const csrf = document.cookie.match(/(?:^|;\s*)__Host-paypro_csrf=([^;]+)/)?.[1];
  if (csrf) headers['X-CSRF-Token'] = decodeURIComponent(csrf);

  const res = await fetch(BASE + path, {
    method,
    headers,
    credentials: 'include',
    body: body !== undefined && !(body instanceof FormData) ? JSON.stringify(body) : body,
    ...opts,
  });

  const isJson = (res.headers.get('content-type') || '').includes('application/json');
  const data = isJson ? await res.json().catch(() => null) : await res.blob();

  if (!res.ok) {
    const msg = (data && data.error) || res.statusText || 'Request failed';
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    err.code = data?.code || null;
    if (res.status === 401) {
      useAuthStore.getState().logout();
    }
    throw err;
  }
  return data;
}

export const api = {
  get: (path, opts) => request('GET', path, undefined, opts),
  post: (path, body, opts) => request('POST', path, body, opts),
  put: (path, body, opts) => request('PUT', path, body, opts),
  patch: (path, body, opts) => request('PATCH', path, body, opts),
  del: (path, opts) => request('DELETE', path, undefined, opts),
  raw: request,
  importSalaryComponents: (type, rows) => request('POST', '/salary-components/import', { type, rows }),
  importAllowances: (rows) => request('POST', '/salary-components/import', { type: 'allowance', rows }),
  importAttendance: (rows, mode = 'overwrite', dryRun = false) =>
    request('POST', '/attendance/import', { rows, mode, dryRun }),
  importEmployees: (rows, mode, dryRun) =>
    request('POST', '/employees/import', { rows, mode, dryRun }),
  importLeaveRequests: (rows) => request('POST', '/leave/import/requests', { rows }),
  importLeaveBalances: (rows) => request('POST', '/leave/import/balances', { rows }),
  lockStatus: (year, month) => request('GET', `/payroll/runs/lock-status?year=${year}&month=${month}`),
  blob: async (path) => {
    const blob = await request('GET', path, undefined, {});
    return URL.createObjectURL(blob);
  },
  download: async (path, filename) => {
    const blob = await request('GET', path, undefined, {});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
